import React from 'react';

import { TableBasicInput } from './table-basic-input';

export interface TableTextInputProps {
  value: string | null;
  onChange: (value: string | null) => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  hasError?: boolean;
}

/**
 * Simple text input for table inline editing
 * No special validation, direct string handling.
 */
export const TableTextInput: React.FC<TableTextInputProps> = ({
  value,
  onChange,
  onBlur,
  onKeyDown,
  disabled,
  autoFocus,
  className,
  hasError = false,
}) => {
  return (
    <TableBasicInput
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      disabled={disabled}
      autoFocus={autoFocus}
      className={className}
      hasError={hasError}
      align="left"
    />
  );
};
